import React, { useContext, useState } from 'react';
import { ListItemIcon, ListItemText, Menu, MenuItem, Switch } from '@mui/material';
import { AuthContext } from '../../context/auth';
import { AlertModalContext } from '../modal/alert';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import CambiarEstablecimientoDialog from '../modal/cambiarEstablecimiento';
import { GlobalsContext } from '../../context/globals';
import { postData } from '../../services/ajax/';
import { LoadingModalContext } from '../modal/loading';
import { clearSessionEndNotice, resetSessionEndGuard } from '../../services/sessionEnd';


export default function UserMenu(props) {
    const { anchorEl, onClose, onClick, } = props;
    const { usuario, updateUsuario } = useContext(AuthContext);
    const { showModal } = useContext(AlertModalContext);

    const globalsContext = useContext(GlobalsContext);
    const loadingModal = useContext(LoadingModalContext);

    const handleLogout = async () => {
        showModal(
            "Cerrar sesión",
            "¿Estás seguro que deseas cerrar la sesión?",
            async function () {
                loadingModal.setOpen(true);
                try {
                    // Invalidar el token en el servidor si hay usuario y token
                    if (usuario && usuario.token) {
                        const logoutResponse = await postData("auth/logout", {}, usuario.token);
                        // Verificar si hubo error en la respuesta
                        if (logoutResponse.error) {
                            console.warn("Error al invalidar token en el servidor:", logoutResponse.error);
                        }
                    }
                } catch (error) {
                    // Si falla el logout en el servidor, continuamos con el logout local
                    console.warn("Error al invalidar token en el servidor:", error);
                } finally {
                    // Siempre limpiar el usuario localmente, incluso si falla el logout en el servidor
                    clearSessionEndNotice();
                    resetSessionEndGuard();
                    updateUsuario(null);
                    loadingModal.setOpen(false);
                }
            });
    }

    const handleChangeDarkMode = (e = false) => {
        globalsContext.setDarkModeOn(!globalsContext.darkModeOn);
    };

    return (
        <div>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={anchorEl != null}
                onClose={onClose}
                onClick={onClick}
            /*transformOrigin={{ horizontal: 'right', vertical: 'top' }}*/
            /*anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}*/
            >
                {/*<MenuItem onClick={handleChangeEstablecimiento} >
                    <ListItemIcon> <BusinessRoundedIcon fontSize="medium" /> </ListItemIcon>
                    Cambiar Establecimiento
                </MenuItem>*/}

                <MenuItem onClick={handleChangeDarkMode}>
                    <ListItemIcon>
                        <DarkModeRoundedIcon />
                    </ListItemIcon>
                    <ListItemText id="switch-list-label-darkMode" primary="Modo noche" />
                    <Switch
                        edge="end"
                        onChange={handleChangeDarkMode}
                        checked={globalsContext.darkModeOn}
                        slotProps={{
                            input: {
                                'aria-labelledby': 'switch-list-label-darkMode',
                            }
                        }}
                    />
                </MenuItem>

                <MenuItem onClick={handleLogout} >
                    <ListItemIcon> <LogoutRoundedIcon fontSize="medium" /> </ListItemIcon>
                    Cerrar Sesión
                </MenuItem>
            </Menu>
        </div>
    );
}